import { render, staticRenderFns } from "./RigRequirements.vue?vue&type=template&id=ebc2c88e&"
import script from "./RigRequirements.vue?vue&type=script&lang=js&"
export * from "./RigRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports